import { render } from "./modalPendingProposal.vue?vue&type=template&id=66b6b26f&scoped=true"
import script from "./modalPendingProposal.vue?vue&type=script&lang=js"
export * from "./modalPendingProposal.vue?vue&type=script&lang=js"

import "./modalPendingProposal.vue?vue&type=style&index=0&id=66b6b26f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b6b26f"]])

export default __exports__